import React, { useMemo } from 'react';
import { useImqBrokerHealthQuestionnaireParams } from 'global/hooks/useImqBrokerHealthQuestionnaireParams';
import ImqBrokerHealthQuestionnairePageStore, {
  ImqBrokerHealthQuestionnairePageStoreContext,
} from 'store/pages/quote/imq-add-employees/health-questionnaire/pageStore';
import { PageContent } from 'components/quote/imq-add-employees/health-questionnaire';

const ImqBrokerHealthQuestionnairePage: React.FC = () => {
  const domainParams = useImqBrokerHealthQuestionnaireParams();

  const pageStore = useMemo(
    () => new ImqBrokerHealthQuestionnairePageStore(domainParams),
    [
      domainParams.groupId,
      domainParams.periodId,
      domainParams.cartId,
      domainParams.subscriberId,
      domainParams.entityId,
    ],
  );

  return (
    <ImqBrokerHealthQuestionnairePageStoreContext.Provider value={pageStore}>
      <PageContent />
    </ImqBrokerHealthQuestionnairePageStoreContext.Provider>
  );
};

export default ImqBrokerHealthQuestionnairePage;
